import i from "./IstPopover.vue.mjs";
import r from "./IstTooltip.vue.mjs";
import { tooltipDirective as l } from "./directive.mjs";
const m = {
  install(o, t = { tooltip: void 0 }) {
    document.addEventListener("resize", (e) => {
      console.log("resize", e);
    }), o.component("IstPopover", i), o.directive("istPopover", l), t.tooltip && o.component("IstTooltip", r);
  }
};
export {
  m as default
};
